// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"399":"1bcb1dea","838":"a3f71a03"}[chunkId] + ".chunk.js";
};